var exports = {
  "F": "HeaderOverflow.module__magnifier___cG1fck",
  "r": "HeaderOverflow.module__menuIcon___cG1fck",
};

module.exports = exports;
